import { render, staticRenderFns } from "./valuable-concepts-modal-skeletons-tabs.vue?vue&type=template&id=c8b4a6a4&"
import script from "./valuable-concepts-modal-skeletons-tabs.ts?vue&type=script&lang=ts&"
export * from "./valuable-concepts-modal-skeletons-tabs.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports